// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"6f01cbb4","209":"e1f55257","367":"e964645f","453":"5424893a","478":"2755273b","625":"c77327cf","745":"4cdb9fc4","922":"a9748d02","964":"5b7d9178"}[chunkId] + ".chunk.js";
};